import React from "react";
import styled from "styled-components";
import tw from "twin.macro";
import { ReactComponent as SvgDotPatternIcon } from "../../images/dot-pattern.svg";
import { SectionHeading as HeadingTitle } from "../misc/Headings.js";
import cleaning1 from "images/cleaning1.jpg";
import cleaning2 from "images/cleaning2.jpg";
import cleaning3 from "images/cleaning3.jpg";
import cleaning4 from "images/cleaning4.jpg";
import getLocaleString from "utils/getLocaleString";

const Container = tw.div`relative`;

const SingleColumn = tw.div`max-w-screen-xl mx-auto py-20 lg:py-24`;

const HeadingInfoContainer = tw.div`flex flex-col items-center`;
const HeadingDescription = tw.p`mt-4 font-medium text-gray-600 text-center max-w-screen-md`;

const Content = tw.div`mt-16`;

const Card = styled.div((props) => [
  tw`mt-24 md:flex justify-center items-center`,
  props.reversed ? tw`flex-row-reverse` : "flex-row",
]);
const Image = styled.div((props) => [
  `background-image: url("${props.imageSrc}");`,
  tw`rounded md:w-1/2 lg:w-5/12 xl:w-1/3 flex-shrink-0 h-80 md:h-144 bg-cover bg-center mx-4 sm:mx-8 md:mx-4 lg:mx-8`,
]);
const Details = tw.div`mt-4 md:mt-0 md:max-w-md mx-4 sm:mx-8 md:mx-4 lg:mx-8`;
const Subtitle = tw.div`font-bold tracking-wide text-secondary-100`;
const Title = tw.h4`text-3xl font-bold text-gray-900`;
const Description = tw.p`mt-2 text-sm leading-loose`;

const SvgDotPattern1 = tw(
  SvgDotPatternIcon
)`absolute top-0 left-0 transform -translate-x-20 rotate-90 translate-y-8 -z-10 opacity-25 text-primary-500 fill-current w-24`;
const SvgDotPattern2 = tw(
  SvgDotPatternIcon
)`absolute top-0 right-0 transform translate-x-20 rotate-45 translate-y-24 -z-10 opacity-25 text-primary-500 fill-current w-24`;
const SvgDotPattern3 = tw(
  SvgDotPatternIcon
)`absolute bottom-0 left-0 transform -translate-x-20 rotate-45 -translate-y-8 -z-10 opacity-25 text-primary-500 fill-current w-24`;
const SvgDotPattern4 = tw(
  SvgDotPatternIcon
)`absolute bottom-0 right-0 transform translate-x-20 rotate-90 -translate-y-24 -z-10 opacity-25 text-primary-500 fill-current w-24`;

export default ({ locale }) => {
  const cards = [
    {
      imageSrc: cleaning1,
      title: (
        <>
          {getLocaleString("Card1Title1", locale)}
          <span style={{ color: "#11c2cf" }}>
            {getLocaleString("Card1Title2", locale)}
          </span>
          {getLocaleString("Card1Title3", locale)}
        </>
      ),
      description: getLocaleString("Card1Description", locale),
    },

    {
      imageSrc: cleaning2,
      title: (
        <>
          {getLocaleString("Card2Title1", locale)}
          <span style={{ color: "#11c2cf" }}>
            {getLocaleString("Card2Title2", locale)}
          </span>
        </>
      ),
      description: getLocaleString("Card2Description", locale),
    },

    {
      imageSrc: cleaning3,
      title: (
        <>
          {getLocaleString("Card3Title1", locale)}
          <span style={{ color: "#11c2cf" }}>
            {getLocaleString("Card3Title2", locale)}
          </span>
          {getLocaleString("Card3Title3", locale)}
        </>
      ),
      description: getLocaleString("Card3Description", locale),
    },

    {
      imageSrc: cleaning4,
      title: (
        <>
          {getLocaleString("Card4Title1", locale)}
          <span style={{ color: "#11c2cf" }}>
            {getLocaleString("Card4Title2", locale)}
          </span>
        </>
      ),
      description: getLocaleString("Card4Description", locale),
    },
  ];

  return (
    <Container>
      <SingleColumn>
        <HeadingInfoContainer>
          <HeadingTitle>
            {getLocaleString("FeatureHeading1", locale)}
            <span style={{ color: "#11c2cf" }}>
              {getLocaleString("FeatureHeading2", locale)}
            </span>
            {getLocaleString("FeatureHeading3", locale)}
          </HeadingTitle>
          <HeadingDescription>
            {getLocaleString("FeatureDescription", locale)}
          </HeadingDescription>
        </HeadingInfoContainer>

        <Content>
          {cards.map((card, i) => (
            <Card key={i} reversed={i % 2 === 1}>
              <Image imageSrc={card.imageSrc} />
              <Details>
                <Subtitle>{card.subtitle}</Subtitle>
                <Title>{card.title}</Title>
                <Description>{card.description}</Description>
              </Details>
            </Card>
          ))}
        </Content>
      </SingleColumn>
      <SvgDotPattern1 />
      <SvgDotPattern2 />
      <SvgDotPattern3 />
      <SvgDotPattern4 />
    </Container>
  );
};
